module.exports = __webpack_public_path__ + "fonts/mem5YaGs126MiZpBA-UN7rgOUuhp.0edb7628.woff2";